import { defineStore } from "pinia";
import {
  BlockContent,
  IBlockTranslation,
  RichTextModuleData,
  FooterFormModuleData,
} from "ecom-types";

interface State {
  footer: {
    copyright: string | undefined;
    leftColumn: BlockContent | undefined;
    rightColumn: string | undefined;
    centerColumn: string | undefined;
    certificatesEntities: RichTextModuleData | null | undefined;
    bottomInfo: BlockContent | undefined;
    footerForm: FooterFormModuleData | null | undefined;
  };
  isSignInDrawerOpen: boolean;
  isSignUpDrawerOpen: boolean;
  systemData: {
    loginFooter: RichTextModuleData | null;
  };
  systemOverlay: boolean;
  systemLoader: boolean;
}

export const useGeneralInternalStore = defineStore("generalInternal", {
  state: (): State => ({
    footer: {
      copyright: "",
      leftColumn: undefined,
      rightColumn: "",
      centerColumn: "",
      certificatesEntities: null,
      bottomInfo: undefined,
      footerForm: null,
    },
    isSignInDrawerOpen: false,
    isSignUpDrawerOpen: false,
    systemData: {
      loginFooter: null,
    },
    systemOverlay: false,
    systemLoader: false,
  }),

  actions: {
    async getBlocks() {
      const { $api } = useNuxtApp();
      const { data: apiData } = await useAsyncData(
        "getBaseBlocks",
        async () => {
          const [
            responseCopyright,
            responseSystemLoginFooter,
            responseFooterForm,
          ] = await Promise.all([
            $api.blocks.getBlock("footer-copyright"),
            $api.blocks.getBlock("system-login-footer"),
            $api.blocks.getBlock("footer-form"),
            $api.blocks.getBlock("footer-bottom-info"),
          ]);
          return {
            dataCopyright: responseCopyright?.data,
            dataSystemLoginFooter: responseSystemLoginFooter?.data,
            dataFooterForm: responseFooterForm?.data,
          };
        },
      );

      const { dataCopyright, dataSystemLoginFooter, dataFooterForm } =
        apiData.value || {};

      this.footer.copyright =
        (dataCopyright?.currentTranslation as IBlockTranslation<BlockContent>)
          ?.content?.content || "";

      this.systemData.loginFooter =
        ((
          dataSystemLoginFooter?.currentTranslation as IBlockTranslation<BlockContent>
        )?.content as RichTextModuleData) || "";

      this.footer.footerForm =
        ((dataFooterForm?.currentTranslation as IBlockTranslation<BlockContent>)
          ?.content as FooterFormModuleData) || "";
    },
  },
});
